import { SECTION1 } from './section1';

const Schedule2 = {
  SECTION1,
};

export default Schedule2;
